<script>
  import { page } from '@inertiajs/svelte'
  import Button from './ui/button.svelte'

  // Derive straight from page props; `hidden` tracks the flash object the user
  // dismissed (or that timed out) so the same message doesn't reappear.
  let hidden = $state.raw(null)
  const flash = $derived($page.props.flash || {})
  const visible = $derived(hidden === flash ? {} : flash)

  // A warning carries detail the admin has to act on, so it stays until dismissed.
  const warningLines = $derived((visible.warning || '').split('\n'))

  $effect(() => {
    if ((flash.alert || flash.notice) && !flash.warning) {
      const current = flash
      const timeoutId = setTimeout(() => {
        hidden = current
      }, 5000)
      return () => clearTimeout(timeoutId)
    }
  })

  const dismiss = () => {
    hidden = flash
  }
</script>

{#if visible.alert}
  <div class="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
    <div class="alert alert-error shadow max-w-md">
      <span>{visible.alert}</span>
      <Button variant="ghost" size="sm" circle icon="close" class="ml-auto" aria-label="Close alert" onclick={dismiss} />
    </div>
  </div>
{/if}

{#if visible.notice}
  <div class="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
    <div class="alert alert-success shadow max-w-md">
      <span>{visible.notice}</span>
      <Button variant="ghost" size="sm" circle icon="close" class="ml-auto" aria-label="Close notification" onclick={dismiss} />
    </div>
  </div>
{/if}

{#if visible.warning}
  <div class="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
    <div class="alert alert-warning shadow max-w-2xl items-start" role="alert">
      <div class="text-sm">
        <p class="font-semibold">{warningLines[0]}</p>
        {#if warningLines.length > 1}
          <p class="whitespace-pre-line mt-1">{warningLines.slice(1).join('\n')}</p>
        {/if}
      </div>
      <Button variant="ghost" size="sm" circle icon="close" class="ml-auto" aria-label="Close warning" onclick={dismiss} />
    </div>
  </div>
{/if}
